export default __webpack_public_path__ + "static/media/illustration-algohealth-m.f1e1252d.webp";